import React from "react";
import ReactECharts from "echarts-for-react";
import "moment/locale/pt-br";
import { capitalize } from "lodash";
import { formatDate, numberToCurrency } from "../../../../../utils/formatters";
import { EarningsChartWrapper } from "./Styled";

type Props = {
  data: {
    amount_value: number;
    earnings: Record<string, number>;
    balance: Record<string, number>;
  };
};

const EarningsChart: React.FC<Props> = ({ data }) => {
  const labels = ["Rendimento", "Saldo"];

  const { amount_value, earnings, balance } = data || {};

  const formattedDates = Object.keys(earnings).map((date) =>
    capitalize(formatDate(date, "MMM"))
  );

  const options = {
    tooltip: { trigger: "axis" },
    legend: { data: labels },
    grid: {
      left: 0,
      right: 0,
      containLabel: true,
    },
    xAxis: {
      data: formattedDates,
      axisPointer: { type: "shadow" },
    },
    yAxis: [
      {
        name: labels[0],
        alignTicks: true,
        axisLabel: {
          formatter: (value: number) => numberToCurrency(value),
        },
      },
      {
        name: labels[1],
        min: amount_value,
        alignTicks: true,
        axisLabel: {
          formatter: (value: number) => numberToCurrency(value),
        },
      },
    ],
    series: [
      {
        name: labels[0],
        type: "bar",
        data: Object.values(earnings),
        barMaxWidth: 120,
        itemStyle: { color: "#1f4ca0" },
        tooltip: { valueFormatter: (value: number) => numberToCurrency(value) },
      },
      {
        name: labels[1],
        type: "line",
        yAxisIndex: 1,
        data: Object.values(balance),
        symbolSize: 8,
        itemStyle: { color: "#05dc7f" },
        lineStyle: { width: 4 },
        tooltip: { valueFormatter: (value: number) => numberToCurrency(value) },
      },
    ],
  };

  return (
    <EarningsChartWrapper>
      <ReactECharts option={options} style={{ height: 400 }} />
    </EarningsChartWrapper>
  );
};

export default EarningsChart;
